var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vld-parent"},[_c('loading',{attrs:{"active":_vm.isLoading || !!_vm.load,"opacity":_vm.isFull ? 1 : 0.5}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }